import { Loader } from "../../../components/loader";
import { Amount } from "../../../components/widget/text-widget";
import { useFetchable } from "../../../store/common/fetchable";
import { Verification } from "../../../store/verification/reducer";
import { FraudRoutes } from "../../kyc-kyb-aml/routes";
import { StyledTextWidget } from "./common";

export const KycKybPerformedTile = () => {
  const verificationChecksSummaryFetchable = useFetchable(
    Verification.checksSummary
  );

  return (
    <Loader data={[verificationChecksSummaryFetchable]}>
      {([verifcationChecks]) => (
        <StyledTextWidget
          title="KYC & KYB Checks Performed:"
          to={FraudRoutes.names.allIndividualKyc}
        >
          <Amount>
            {(verifcationChecks.kycChecks?.totalFromBeginningOfTime || 0) +
              (verifcationChecks.kybChecks?.totalFromBeginningOfTime || 0)}
          </Amount>{" "}
          checks
        </StyledTextWidget>
      )}
    </Loader>
  );
};
